import { render } from "./SubMenu.vue?vue&type=template&id=5f135134"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&id=5f135134&lang=css"

import exportComponent from "C:\\work\\takeda\\ui\\takeda_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/module/menu/SubMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f135134"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f135134', __exports__)) {
    console.log('reload')
    api.reload('5f135134', __exports__)
  }
  
  module.hot.accept("./SubMenu.vue?vue&type=template&id=5f135134", () => {
    console.log('re-render')
    api.rerender('5f135134', render)
  })

}


export default __exports__